<form>
  <!-- User Firstname-->
  <div class="form-group label-floating">
    <label class="control-label" for="userFirstName">Firstname</label>
    <input id="userFirstName" name="userFirstName" type="text" class="form-control"
      [(ngModel)]="currentUser.userFirstName" disabled>
    </div>

    <!-- User Name -->
    <div class="form-group label-floating">
      <label class="control-label" for="userName">Name</label>
      <input id="userName" name="userName" type="text" class="form-control" [(ngModel)]="currentUser.userName" disabled>
    </div>

    <!-- User Mail address -->
    <div class="form-group label-floating">
      <label class="control-label" for="userMailAddress">Mail address</label>
      <input id="userMailAddress" name="userMailAddress" type="text" class="form-control"
        [(ngModel)]="currentUser.userMailAddress" disabled>
      </div>

      <!-- User Avatar  -->
      <div class="form-group label-floating">
        <label class="control-label" for="userAvatar">Avatar</label>
        <div class="settings-div">
          @if (!currentUser.avatar) {
            <div class="avatar-icon" [ngClass]="getStyle(currentUser.userName)">
              {{currentUser?.userLogin | trigrammePipe}}
            </div>
          }
          @if (currentUser.avatar) {
            <img class="avatar-icon" [src]="currentUser.avatar">
          }

          <label class="btn btn-raised">
            <input type="file" class="form-control" id="userAvatar" name="userAvatar[]" (change)="onChangeAvatar($event)">
            Pick a file
          </label>
          @if (currentUser.avatar) {
            <button class="btn btn-raised" (click)="removeAvatar()">
              Reset
            </button>
          }
        </div>
      </div>

      <!-- User Phone number -->
      <div class="form-group label-floating" [ngClass]="{ 'is-empty': !currentUser.userPhoneNumber}">
        <label class="control-label" for="userPhoneNumber">Phone number</label>
        <input id="userPhoneNumber" name="userPhoneNumber" type="text" class="form-control"
          [(ngModel)]="currentUser.userPhoneNumber">
        </div>

        <!-- New Password -->
        <div class="form-group label-floating"
          [ngClass]="{ 'has-error': newPassword != confirmNewPassword, 'is-empty': newPassword === '' }">
          <label class="control-label" for="userPassword">New password</label>
          <input id="userPassword" name="userPassword" type="password" class="form-control" [(ngModel)]="newPassword"
            aria-describedby="help-userPassword">
            @if (newPassword != confirmNewPassword) {
              <span id="help-userPassword" class="help-block">Password does not match the confirmation</span>
            }
          </div>

          <!-- Confirm Password -->
          <div class="form-group label-floating" [ngClass]="{ 'is-empty': confirmNewPassword === '' }">
            <label class="control-label" for="userConfirmPassword">Confirm password</label>
            <input id="userConfirmPassword" name="userConfirmPassword" type="password" class="form-control"
              [(ngModel)]="confirmNewPassword">
            </div>

            <!-- Enable timesheet monthly export -->
            <div class="form-group label-floating" style="margin-bottom: 20px;">
              <label class="control-label" [class.label-grey]="!monthlyTimesheet">Enable timesheet monthly export by email</label>
              <div>
                <label class="switch">
                  <input type="checkbox" [(ngModel)]="monthlyTimesheet" name="monthlyTimesheet">
                  <div class="slider round"></div>
                </label>
              </div>
            </div>

            <!-- Timesheet approved by -->
            <div class="form-group label-floating">
              <label class="control-label" for="timesheetApprovedBy">Timesheet approuved by</label>
              <input id="timesheetApprovedBy" name="timesheetApprovedBy" type="text" class="form-control"
                [(ngModel)]="timesheetApprovedBy">
              </div>

              <!-- SAVE -->
              <div class="text-center">
                <button id="singlebutton" name="singlebutton" class="btn btn-raised primary" (click)="updateData()"
                  [disabled]="newPassword != confirmNewPassword">Save
                </button>
                <button (click)="cancel()" class="btn btn-raised">Cancel</button>
              </div>
            </form>
            <!-- NOTIFICATION -->
            @if (showAlert) {
              <notification [timeout]="10000" [severity]="notifType" [message]="notifMessage"
              (hideNotification)="showAlert = false"></notification>
            }
